import { render } from "./AdminGlobalCodes.vue?vue&type=template&id=ba1d982a"
import script from "./AdminGlobalCodes.vue?vue&type=script&lang=js"
export * from "./AdminGlobalCodes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__